import { StorageBackendClient } from './storageBackendClient.js';

/**
 * API-only storage client.
 *
 * We keep the historical `s3Service.*` interface so existing UI code doesn't need
 * sweeping refactors, but every operation is routed through HalalCredApi.
 */
const client = new StorageBackendClient();

const s3Service = {
  isReady() {
    return client.isReady();
  },
  initialize() {
    return client.initialize();
  },
  uploadFile(file, partnerId, documentType) {
    return client.uploadFile(file, partnerId, documentType);
  },
  deleteFile(s3Key) {
    return client.deleteFile(s3Key);
  },
  getSignedUrl(s3Key, expiresInOrOpts) {
    return client.getSignedUrl(s3Key, expiresInOrOpts);
  },
  listFiles(prefix, maxKeys) {
    return client.listFiles(prefix, maxKeys);
  },
  uploadResourceFile(file) {
    return client.uploadResourceFile(file);
  },
  uploadGenericResource(file, resourceType, folder) {
    return client.uploadGenericResource(file, resourceType, folder);
  }
};

export default s3Service;
